<template>
    <v-dialog v-model="dialogSwitch" persistent scrollable width="800">
        <v-card>
            <v-card-title id="heading" class="d-flex justify-space-between">
                <div>
                    <h4>Device OTAs status: {{ device.slno }}</h4>
                </div>
                <v-btn density="compact" icon="mdi-close" variant="flat"
                       @click="$emit('update:modelValue', false)"/>
            </v-card-title>

            <v-container>
                <v-row>
                    <v-col cols="12">
                        <v-table>
                            <thead>
                            <tr>
                                <th>Campaign</th>
                                <th>File</th>
                                <th>Attempts</th>
                                <th>Downloading</th>
                                <th>Download Progress</th>
                                <th>Status</th>
                                <th>Action</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr
                                v-for="(status, index) in otaStatus"
                                v-if="!loading && otaStatus.length"
                                :key="index"
                                class="text-left"
                            >
                                <td>{{ status.campaign_name }}</td>
                                <td>{{ status.file_name }}</td>
                                <td>{{ status.attempts }}</td>
                                <td>
                                    <v-icon :icon="`mdi-${status.is_downloading?'check':'close'}-circle`"/>
                                </td>
                                <td>
                                    <v-progress-linear
                                        :model-value="status.download_percentage"
                                        height="20">
                                        <small :class="{'text-white': (status.download_percentage>35)}">{{
                                                Math.ceil(status.download_percentage)
                                            }}%</small>
                                    </v-progress-linear>
                                </td>
                                <td>{{ status.status }}</td>
                                <td>
                                    <v-btn-group density="compact" divided variant="outlined">
                                        <v-btn class="text-red" size="x-small" @click="updateStatus(status)">
                                            Disable
                                        </v-btn>
                                        <v-btn class="text-indigo" size="x-small" @click="updateStatus(status,1)">
                                            Requeue
                                        </v-btn>
                                    </v-btn-group>
                                </td>
                            </tr>
                            <tr v-else>
                                <td v-if="loading" class="text-center" colspan="7">
                                    <v-progress-circular color="primary" indeterminate/>
                                </td>
                                <td v-else class="text-center" colspan="7">No record found</td>
                            </tr>
                            </tbody>
                        </v-table>
                    </v-col>
                </v-row>

                <v-row v-if="totalPages > 1" justify="center">
                    <v-col cols="8">
                        <v-pagination
                            v-model="currentPage"
                            :length="totalPages"
                            class="my-4"
                            density="compact"
                            @update:model-value="fetchOtaStatus"
                        ></v-pagination>
                    </v-col>
                </v-row>
            </v-container>

            <v-card-actions class="px-4 d-flex justify-end">
                <v-btn
                    size="small"
                    type="button"
                    @click="$emit('update:modelValue', false);"
                >
                    Close
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script setup>
import {ref, onMounted} from "vue";
import {send} from "@/composables/apiClient";
import {useSnackbarStore} from "@/stores/snackBarStore";

const {showSnackbar} = useSnackbarStore();
const props = defineProps({
    modelValue: Boolean,
    device: Object,
});
const dialogSwitch = ref(props.modelValue);
const loading = ref(true);
const currentPage = ref(1);
const totalPages = ref(1);
const otaStatus = ref([]);

const emits = defineEmits(["update:modelValue"]);
onMounted(() => {
    fetchOtaStatus();
});

const fetchOtaStatus = () => {
    loading.value = true;
    send("get", `devices/${props.device.id}/ota-campaigns-status`, {
        page: currentPage.value,
    }).then((response) => {
        otaStatus.value = response.data.data.data;
        totalPages.value = response.data.data.meta.last_page;
        currentPage.value = response.data.data.meta.current_page;
    }).catch((error) => {
        showSnackbar(error.response?.data?.message ?? "Campaign devices status could not be loaded", "error");
    }).finally(() => loading.value = false);
}
const updateStatus = (campaignStatus, status = 0) => {
    if (!confirm(`Are you sure you want to update ota status to: "${status === 0 ? 'Disable' : 'Requeue'}" for campaign: "${campaignStatus.campaign_name}"?`)) {
        return;
    }
    loading.value = true;
    send("put", `admin/ota/campaigns/update-devices-status/${campaignStatus.id}`, {status: status})
        .then((response) => {
            if (response.data.success) {
                showSnackbar(response.data.message ?? "Campaign status updated successfully");
                fetchOtaStatus();
            }
        }).catch((error) => {
        showSnackbar(error.response?.data?.message ?? "Campaign status could not be updated", "error");
    }).finally(() => loading.value = false);
}
</script>
